import { TFunction } from "i18next";
import { ISpeakingLevel } from "./ISpeakingLevel.ts";
import { SpeakingLevel } from "../../gql/graphql.ts";

export class VoyagerLevel implements ISpeakingLevel {
  is(level: string): boolean {
    return level === this.getId();
  }
  getId(): SpeakingLevel {
    return SpeakingLevel.Voyagers;
  }
  getBgColorClass(): string {
    return "bg-norma-voyager";
  }

  getLevelDescription(t: TFunction<"levelDesc">): string {
    return t("voyagers");
  }

  getLevelTitle(t: TFunction<"levelTitle">): string {
    return t("voyagers");
  }

  getTextColorClass(): string {
    return "text-norma-voyager";
  }

  getTextOnBgColorClass(): string {
    return "text-white";
  }
}
